<template>
  <div class="app-container">
    <div class="flex h-30 align-center mb-10">
      <div class="title w-0 bg-ff flex-1 flex align-center mr-20 plr-10">
        <div class="flex-1 flex">
          <el-tabs v-model="tabValue" type="card" class="flex-1 w-0 pr-10 mr-10" @tab-click="switchTab" style="height: 30px;">
            <el-tab-pane v-for="(item, index) in tab" :key="index" :label="item.name" :name="item.name" v-if="tabPermissions.indexOf(item.status.toString()) !== -1"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="flex align-center h-100 cursor pl-10" style="border-left: 1px solid #e2e2e2;" @click="switchAll(-1)">
          <div class="mr-5" :class="tabValue === '-1' ? 'decoration-line' : 'decoration-line-hui'"></div>
          <div class="font-bold" :class="tabValue === '-1' ? 'font-16-f5971d' : 'font-16-30313a'">全部</div>
        </div>
      </div>
      <div class="flex ml-10">
        <div class="flex  align-center ">
          <el-date-picker
            v-model="startTime"
            type="date"
            placeholder="编制开始时间"
            value-format="yyyy-MM-dd">
          </el-date-picker>
          <span class="font-12-b9b9b9" style="width: 24px;border: 1px solid #e2e2e2;height: 30px; line-height: 30px;">至</span>
          <el-date-picker
            v-model="endTime"
            type="date"
            @change="judge"
            placeholder="编制结束时间"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input class=" font-12-85" type="text" placeholder="输入关键字" v-model="inputValue" clearable @keyup.enter.native="searchBtn"></el-input>
          </div>
          <button class="btn-30-bg-82b925" @click="searchBtn">搜索</button>
        </div>
      </div>
    </div>
    <div class="mb-5 flex align-center">
      <div class="flex align-center mr-5 mb-5" @click="onOperate(item)" :class="index === Index ? 'btn-24-bg-f5971d' : 'btn-24-bg-ff' " @mouseenter="enter(index)" @mouseleave="leave(index)" v-for="(item, index) in btnList" :key="index" v-if="btnPermissions.indexOf(item.label) !== -1">
        <img :src="index === Index ? item.iconActive : item.icon" class="icon-14 mr-5" alt="">
        <div>{{item.name}}</div>
      </div>
    </div>
    <div class="flex-1 h-0 flex-column">
      <div class="flex-1 h-0">
        <erp-table ref="erpTable" :customs="customs" :table-footer="tableFooter" :table-data="tableData"  :loading="loading" @on-log="onLog" @on-detail="onDetail" :column-data="columnData"></erp-table>
      </div>
      <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
    </div>
    <!--<div class="flex-1">-->
      <!--<erp-table ref="erpTable" :table-footer="tableFooter" :table-data="tableData"  :loading="loading" @on-log="onLog" @on-detail="onDetail" :column-data="columnData"></erp-table>-->
    <!--</div>-->
    <!--<div style="margin-top: 10px;margin-bottom: 20px">-->
      <!--<Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>-->
    <!--</div>-->
    <log ref="log" :detailItem="detailItem"></log>
    <edit-receipt ref="editReceipt" :receiptStatus="receiptStatus" :tabStatus="tabStatus" :orderType="orderType" :orderDefine="orderDefine" :detailItem="detailItem" v-if="editFlag" :backName="backName" :isEdit="true" :btnPermissions="btnPermissions"></edit-receipt>
  </div>
</template>

<script>
import ErpTable from '@/components/ErpTable'
import Pagination from '@/components/Pagination'
import Log from './Log'
import EditReceipt from '@/components/AddReceipt'
export default {
  name: 'materialIn',
  components: {ErpTable, Pagination, Log, EditReceipt},
  props: ['orderType', 'columnData', 'backName'],
  data () {
    return {
      Index: -1,
      tabValue: '-1',
      tabStatus: -1,
      startTime: '',
      endTime: '',
      inputValue: '',
      page: 1,
      limit: 25,
      pageSize: 10, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 10, // 当前页条数
      total: 100, // 总条数
      loading: true,
      currentOperate: '',
      detailTitle: '入库单',
      tableFooter: [
        {
          columns: ['totalCost', 'totalCustomer'],
          type: 'sum',
          name: '合计'
        }
      ],
      tableData: [],
      customs: [
        {
          field: 'totalCost',
          visible: false
        },
        {
          field: 'profit',
          visible: false
        }
      ],
      orderDefine: null,
      detailItem: null,
      receiptStatus: 0, // 0新增 1详情
      editFlag: false,
      tab: [{
        name: '开单',
        status: 1
      }, {
        name: '供应商备货',
        status: 2
      }, {
        name: '供应商送货',
        status: 3
      }, {
        name: '供应商送货完成',
        status: 4
      }, {
        name: '已出库',
        status: -3
      }, {
        name: '供货完成',
        status: 5
      }, {
        name: '已结账',
        status: 6
      }, {
        name: '坏账',
        status: 8
      }, {
        name: '作废单据',
        status: 7
      }],
      btnList: [{
        name: '新增单据',
        label: 'add',
        icon: '/static/images/add.png',
        iconActive: '/static/images/add-bai.png'
      }, {
        name: '提交供应商备货',
        label: 'submitBusinessStock',
        icon: '/static/images/customer/shangmenkehu.png',
        iconActive: '/static/images/customer/shangmenkehu-bai.png'
      }, {
        name: '提交送货',
        label: 'submitDelivery',
        icon: '/static/images/customer/shangmenkehu.png',
        iconActive: '/static/images/customer/shangmenkehu-bai.png'
      }, {
        name: '送货完成',
        label: 'finishDelivery',
        icon: '/static/images/customer/shangmenkehu.png',
        iconActive: '/static/images/customer/shangmenkehu-bai.png'
      }, {
        name: '供货完成',
        label: 'supplyComplete',
        icon: '/static/images/customer/shangmenkehu.png',
        iconActive: '/static/images/customer/shangmenkehu-bai.png'
      }, {
        name: '作废单据',
        label: 'cancelOrder',
        icon: '/static/images/zuofei.png',
        iconActive: '/static/images/zuofei-bai.png'
      }, {
        name: '退回开单',
        label: 'back',
        icon: '/static/images/shanchu1.png',
        iconActive: '/static/images/shanchu1-bai.png'
      }],
      tabPermissions: [],
      btnPermissions: []
    }
  },
  created () {},
  mounted () {
    this.getMaterialAuditor()
    this.getTabPermissions()
  },
  methods: {
    getMaterialAuditor () {
      this.axios.post('station/getById', this.qs.stringify({id: this.$store.state.user.roleId})).then(res => {
        if (res.data.success) {
          if (res.data.data.isMaterialAuditor === 1) {
            let customs = []
            for (let i = 0; i < this.customs.length; i++) {
              this.customs[i].visible = true
              customs.push(this.customs[i])
            }
            this.customs = customs
            console.log(this.customs)
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getTabPermissions () {
      this.axios.post(`orderProcess/listStr`, {
        orderType: this.orderType
      }).then(res => {
        if (res.data.success) {
          this.tabPermissions = []
          let arr = res.data.data.split(',')
          arr.forEach((item, index) => {
            if (item !== '') {
              this.tabPermissions.push(item)
            }
          })
          if (this.orderType === 11) {
            this.tabPermissions.push('-3')
          }
          this.tabPermissions = this.tabPermissions.sort()
          for (let i = 0; i < this.tab.length; i++) {
            if (this.tab[i].status.toString() === this.tabPermissions[0]) {
              this.tabValue = this.tab[i].name
              this.tabStatus = this.tabValue === -1 ? -1 : this.tab[i].status
              break
            }
          }
          console.log(this.tabStatus)
          this.$nextTick(() => {
            this.getBtnPermissions()
          })
        }
      })
    },
    getBtnPermissions () {
      if (this.tabValue !== '-1') {
        let params = {
          orderType: this.orderType,
          orderStatus: this.tabStatus === -3 ? 5 : this.tabStatus
        }
        this.axios.post(`orderButton/listStr`, params).then(res => {
          if (res.data.success) {
            this.btnPermissions = []
            let arr = res.data.data.split(',')
            arr.forEach((item, index) => {
              if (item !== '') {
                this.btnPermissions.push(item)
              }
            })
            if (this.tabStatus === -3 && this.orderType === 11) {
              this.btnPermissions.push('finishDelivery')
            }
            // if (this.tabStatus === 5 && this.orderType === 11) {
            //   this.btnPermissions = []
            // }
            console.log(this.btnPermissions)
            this.getOrderDefine()
          }
        })
      } else {
        this.axios.post(`orderButton/listStr`, {
          orderType: this.orderType,
          orderStatus: -1
        }).then(res => {
          if (res.data.success) {
            this.btnPermissions = []
            let arr = res.data.data.split(',')
            arr.forEach((item, index) => {
              if (item !== '') {
                this.btnPermissions.push(item)
              }
            })
            this.getOrderDefine()
          }
        })
      }
    },
    getOrderDefine () {
      this.axios.post(`orderDefine/findOne`, {
        companyId: this.$store.state.companyId,
        type: this.orderType
      }).then(res => {
        if (res.data.success) {
          this.orderDefine = res.data.data
          this.getData()
        }
      })
    },
    getData () {
      var reg = new RegExp('null', 'g')
      let param
      if (this.tabValue === '-1') {
        param = {
          companyId: this.$store.state.companyId,
          isCancel: -1,
          type: this.orderDefine.type,
          page: this.page,
          limit: this.limit,
          startTime: this.startTime,
          endTime: this.endTime
        }
      } else {
        param = {
          companyId: this.$store.state.companyId,
          type: this.orderDefine.type,
          page: this.page,
          limit: this.limit,
          startTime: this.startTime,
          endTime: this.endTime,
          status: this.tabStatus === -3 ? 5 : this.tabStatus
        }
        if (this.tabStatus === -3 && this.orderType === 11) {
          param.isSend = -1
        }
        if (this.tabStatus === 5 && this.orderType === 11) {
          param.isSend = 1
        }
      }
      if (this.inputValue) {
        param.keywords = this.inputValue
      }
      console.log(this.tabStatus)
      this.axios.post(`order/queryForPage`, param).then(res => {
        if (res.data.success) {
          this.tableData = []
          res.data.data.list.forEach(i => {
            if (this.tabStatus === -1) {
              i.orderStatus = i.statusStr
              i.customerAddress = (i.customerName + '/' + i.address).replace(reg, '')
            } else {
              if (this.tabStatus !== -1) {
                i.status = this.tabStatus === 5 ? i.status = 5 : this.tabStatus === 6 ? i.status = 6 : this.tabStatus === 8 ? i.status = 8 : i.status
              }
              i.orderStatus = i.status === 1 ? '开单' : i.status === 2 ? '供应商备货' : i.status === 3 ? '供应商送货' : i.status === 4 ? '供应商送货完成' : i.status === 5 ? '供货完成' : i.status === 7 ? '作废单据' : i.status === 6 ? '已结账' : i.status === 8 ? '坏账' : ''
              i.customerAddress = (i.customerName + '/' + i.address).replace(reg, '')
            }
            this.tableData.push(i)
          })
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.pageSize
          this.total = res.data.data.total
        }
      })
      this.loading = false
    },
    switchTab (tab, event) {
      this.tabValue = tab.name
      for (let i = 0; i < this.tab.length; i++) {
        if (this.tab[i].name === tab.name) {
          this.tabStatus = this.tab[i].status
          break
        }
      }
      this.$nextTick(() => {
        this.getData()
        this.getBtnPermissions()
      })
    },
    switchAll () {
      this.tabValue = '-1'
      this.tabStatus = -1
      this.getBtnPermissions()
    },
    judge () {
      if (new Date(this.startTime).getTime() > new Date(this.endTime).getTime()) {
        this.$message({
          message: '结束时间不能大于开始时间哟',
          type: 'warning'
        })
      }
    },
    searchBtn () {
      this.page = 1
      this.loading = true
      this.getData()
    },
    onLog (row) {
      this.detailItem = row
      this.$nextTick(() => {
        this.$refs.log.getData()
        this.$refs.log.logVisible = true
      })
    },
    onDetail (row) {
      this.receiptStatus = 1
      this.detailItem = row
      this.editFlag = true
      this.$nextTick(() => {
        this.$refs.editReceipt.customerId = row.customerId
        this.$refs.editReceipt.businessId = row.businessId
        this.$refs.editReceipt.getData()
        this.$refs.editReceipt.controlData = {}
        this.$refs.editReceipt.getOrderControl()
        this.$refs.editReceipt.tableData = []
        this.$refs.editReceipt.addVisible = true
      })
    },
    onOperate (operate) {
      this.currentOperate = operate
      let orderArr = this.$refs.erpTable.getSelectEvent()
      switch (operate.label) {
        case 'add':
          this.detailItem = null
          this.receiptStatus = 0
          this.editFlag = true
          this.$nextTick(() => {
            if (this.orderDefine.type === 10 || this.orderDefine.type === 11 || this.orderDefine.type === 12 || this.orderDefine.type === 13 || this.orderDefine.type === 14 || this.orderDefine.type === 15) {
              this.$refs.editReceipt.getWarehouse()
            }
            this.$refs.editReceipt.controlData = {}
            this.$refs.editReceipt.addVisible = true
          })
          break
        case 'submitBusinessStock':
          if (orderArr.length === 0) {
            this.$message({
              message: `请先选择单据`,
              type: 'warning'
            })
          } else {
            this.handleOrder(orderArr, 2, -1)
          }
          break
        case 'submitDelivery':
          if (orderArr.length === 0) {
            this.$message({
              message: `请先选择单据`,
              type: 'warning'
            })
          } else {
            this.handleOrder(orderArr, 3, -1)
          }
          break
        case 'finishDelivery':
          if (orderArr.length === 0) {
            this.$message({
              message: `请先选择单据`,
              type: 'warning'
            })
          } else {
            if (this.orderType === 11 && this.tabStatus === -3) {
              this.outOrder(orderArr, 1)
            } else {
              this.handleOrder(orderArr, 4, -1)
            }
          }
          break
        case 'supplyComplete':
          if (orderArr.length === 0) {
            this.$message({
              message: `请先选择单据`,
              type: 'warning'
            })
          } else {
            this.handleOrder(orderArr, 5, -1)
          }
          break
        case 'cancelOrder':
          if (orderArr.length === 0) {
            this.$message({
              message: `请先选择单据`,
              type: 'warning'
            })
          } else {
            this.handleOrder(orderArr, 0, 1)
          }
          break
        case 'back':
          if (orderArr.length === 0) {
            this.$message({
              message: `请先选择单据`,
              type: 'warning'
            })
          } else {
            this.handleOrder(orderArr, 1, -1)
          }
          break
      }
    },
    // deleteOrder (customerArr) {
    //   let ids = ''
    //   customerArr.forEach(item => {
    //     if (ids) {
    //       ids = ids + ',' + item.id
    //     } else {
    //       ids = item.id
    //     }
    //   })
    //   let params = {
    //     ids: ids
    //   }
    //   this.axios.post(`order/deleteByIds`, this.qs.stringify(params)).then(res => {
    //     if (res.data.success) {
    //       this.$message({
    //         message: `删除成功`,
    //         type: 'success'
    //       })
    //       this.getData()
    //       this.$refs.erpTable.setAllSelection(false)
    //     } else {
    //       this.$message.error(res.data.msg)
    //     }
    //   })
    // },
    outOrder (arr, status) {
      let idArr = []
      arr.forEach(i => {
        idArr.push(i.id)
      })
      let ids = idArr.join(',')
      let params = {
        ids: ids,
        isSend: 1
      }
      this.$confirm('确定送货完成', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.post(`order/changeStatus`, params).then(res => {
          if (res.data.success) {
            this.$message({
              message: `提交成功`,
              type: 'success'
            })
            this.getData()
            this.$refs.erpTable.setAllSelection(false)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    handleOrder (arr, status, isCancel) {
      let text
      switch (status) {
        case 2:
          text = '是否确定提交供应商备货？'
          break
        case 3:
          text = '是否确定供应商送货？'
          break
        case 4:
          text = '是否确定供应商送货完成？'
          break
        case 5:
          text = '是否确定供货完成？'
          break
        case 0:
          text = '是否确定作废单据？'
          break
        case 1:
          text = '是否退回开单？'
          break
      }
      if (status === 1 && this.tabStatus === 5) {
        this.$message({
          message: `供货完成不能退单`,
          type: 'waring'
        })
      } else {
        let idArr = []
        arr.forEach(i => {
          idArr.push(i.id)
        })
        let ids = idArr.join(',')
        let params
        if (isCancel === 1) {
          params = {
            isCancel: 1,
            ids: ids
          }
        } else {
          params = {
            status: status,
            ids: ids
          }
        }
        this.$confirm(text, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.post(`order/changeStatus`, params).then(res => {
            if (res.data.success) {
              this.$message({
                message: `提交成功`,
                type: 'success'
              })
              this.getData()
              this.$refs.erpTable.setAllSelection(false)
            } else {
              this.$message.error(res.data.msg)
            }
          })
        })
      }
    },
    jump (page) {
      this.page = page
      this.getData()
    },
    enter (a) {
      this.Index = a
      // this.classStyle = true
    },
    leave () {
      this.Index = -2
      // this.classStyle = false
    }
  },
  watch: {
    inputValue (val) {
      if (val === '') {
        this.getData()
      }
    },
    startTime (val) {
      this.getData()
    },
    endTime (val) {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
  .app-container /deep/ .el-input__icon{
    color: #30313a;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .title{
    border-radius: 4px;
  }
  .title /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item{
    border: 0;
    height: 30px;
    line-height: 30px;
  }
  .title /deep/ .el-tabs--card>.el-tabs__header{
    border: 0;
  }
  .title /deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav{
    border: 0;
    display: flex;
  }
  .title /deep/ .el-tabs__header{
    margin: 0;
  }
  .title /deep/ .el-tabs__nav-prev, .title /deep/ .el-tabs__nav-next{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #e2e2e2;
    background-color: #f3f4f7;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    top: 2px;
  }
  .title /deep/ .el-tabs__nav-prev i, .title /deep/ .el-tabs__nav-next i{
    font-weight: bold;
    font-size: 12px;
    color: #30313a;
  }
  .title /deep/ .el-tabs__nav-prev:hover, .title /deep/ .el-tabs__nav-next:hover{
    border-color: #f5971d;
    background: #f5971d;
    color: #fff;
  }
  .title /deep/ .el-tabs__nav-prev:hover i, .title /deep/ .el-tabs__nav-next:hover i{
    color: #fff;
  }
  .title /deep/ .el-tabs__item.is-active{
    color: #f5971d;
    font-weight: bold;
    font-size: 16px;
  }
  .title /deep/ .el-tabs__item{
    color: #30313a;
    font-weight: bold;
    font-size: 16px;
    margin: 0 20px 0 0;
    padding: 0!important;
    display: flex;
    align-items: center;
  }
  .title /deep/ .el-tabs__item:last-child{
    margin: 0;
  }
  .title /deep/ .el-tabs__item:before{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
    content: '';
    display: inline-block;
    margin-right: 5px;
  }
  .title /deep/ .el-tabs__item.is-active:before{
    background-color: #f5971d;
  }
  .title /deep/ .el-tabs__nav-wrap.is-scrollable{
    padding:  0 40px;
  }
  .isAll{
    max-width: 740px;
  }
  .isAll .el-tabs{
    border-right: 1px solid #e2e2e2;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/PageItem.vue